import React, { useState } from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { WhatsAppIcon, TikTokIcon } from './SocialIcons';
import { TermsModal } from './TermsModal';
export function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="bg-primary relative overflow-hidden pt-16 pb-8 border-t border-gold/20" data-id="element-171">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-20 pointer-events-none z-0" data-id="element-172">
        <img src="https://cdn.magicpatterns.com/uploads/uvbMNKvkQxy2nwrmScqdni/9.jpg" alt="" className="w-full h-full object-cover" data-id="element-173" />
        <div className="absolute inset-0 bg-primary/80" data-id="element-174"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-175">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-176">
          {/* Left Column */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-177">
            <img src="https://cdn.magicpatterns.com/uploads/suW15tD8wF6YJTQp7zP6qm/qwwqqwqwqwqwqw-removebg-preview.png" alt="Odontología Estética Logo" className="h-12 w-auto mb-4 logo-invert" data-id="element-178" />
            <h3 className="text-white font-bold text-lg tracking-wide mb-2" data-id="element-179">
              ODONTOLOGÍA ESTÉTICA
            </h3>
            <p className="text-gold italic text-sm mb-2" data-id="element-180">
              "La sonrisa es una curva que lo endereza todo"
            </p>
            <p className="text-gray text-sm" data-id="element-181">Cuídate con nosotros</p>
          </div>

          {/* Center Column */}
          <div className="flex flex-col items-center text-center" data-id="element-182">
            <h4 className="text-gold uppercase text-sm font-bold tracking-widest mb-6" data-id="element-183">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3" data-id="element-184">
              <li data-id="element-185">
                <a href="#inicio" className="text-white hover:text-gold transition-colors" data-id="element-186">
                  Inicio
                </a>
              </li>
              <li data-id="element-187">
                <a href="#servicios" className="text-white hover:text-gold transition-colors" data-id="element-188">
                  Servicios
                </a>
              </li>
              <li data-id="element-189">
                <a href="#resultados" className="text-white hover:text-gold transition-colors" data-id="element-190">
                  Antes y Después
                </a>
              </li>
              <li data-id="element-191">
                <a href="#nosotros" className="text-white hover:text-gold transition-colors" data-id="element-192">
                  Nosotros
                </a>
              </li>
              <li data-id="element-193">
                <a href="#contacto" className="text-white hover:text-gold transition-colors" data-id="element-194">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column */}
          <div className="flex flex-col items-center md:items-end text-center md:text-right" data-id="element-195">
            <h4 className="text-gold uppercase text-sm font-bold tracking-widest mb-6" data-id="element-196">
              Contacto
            </h4>
            <ul className="space-y-3 text-white/90 text-sm" data-id="element-197">
              <li data-id="element-198">📍 Cra. 6 #21-37 Local 1, Pereira</li>
              <li data-id="element-199">📱 301 589 2967</li>
              <li data-id="element-200">📧 odontoesteticapereira@gmail.com</li>
              <li data-id="element-201">🕐 Lun-Vie: 8AM-12PM / 2PM-6PM</li>
            </ul>
          </div>
        </div>

        {/* Social Icons Row */}
        <div className="flex flex-row justify-center gap-5 mb-8" data-id="element-202">
          <a href="https://www.instagram.com/odontologia_estetica_pereira" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold transition-colors" data-id="element-203">
            <Instagram size={28} data-id="element-204" />
          </a>
          <a href="#" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold transition-colors" data-id="element-205">
            <Facebook size={28} data-id="element-206" />
          </a>
          <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold transition-colors" data-id="element-207">
            <WhatsAppIcon size={26} data-id="element-208" />
          </a>
          <a href="https://www.tiktok.com/@odontologia_estetica_pereira" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-white hover:text-gold transition-colors" data-id="element-209">
            <TikTokIcon size={26} data-id="element-210" />
          </a>
        </div>

        <div className="w-full h-px bg-gold/20 mb-6" data-id="element-211"></div>

        {/* Bottom Bar */}
        <div className="text-center" data-id="element-212">
          <p className="text-gray text-xs mb-2" data-id="element-213">
            © 2026 Odontología Estética Pereira. Todos los derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-214">
            <button onClick={() => setIsTermsOpen(true)} className="text-gray hover:text-gold text-xs transition-colors underline-offset-4 hover:underline" data-id="element-215">
              Términos y Condiciones
            </button>
            <span className="text-gray/40 text-xs" data-id="element-216">·</span>
            <button onClick={() => setIsTermsOpen(true)} className="text-gray hover:text-gold text-xs transition-colors underline-offset-4 hover:underline" data-id="element-217">
              Política de Privacidad
            </button>
          </div>
          <p className="text-gray/60 text-xs" data-id="element-218">Diseñado con ❤️ por NovaWeb</p>
        </div>
      </div>
      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-219" />
    </footer>;
}